import { render, staticRenderFns } from "./DpChildSurveyCompletedPage.vue?vue&type=template&id=2cd65e8c&"
import script from "./DpChildSurveyCompletedPage.vue?vue&type=script&lang=ts&"
export * from "./DpChildSurveyCompletedPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports